export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./stayCourse.vue?vue&type=template&id=8871141a&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/views/lesson/component/stayCourse.vue?vue&type=template&id=8871141a&scoped=true&
// module id = null
// module chunks = 